import { Modal } from '@trackman/web-shared-components';
import React from 'react';
import { Content } from './LockedSessionModalStyles';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const LockedSessionModal: React.FC<IProps> = (props) => {
  const { open, onClose } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Session already in use'
      confirmBtn={{
        onClick: onClose,
      }}
      maxWidth={'xs'}
    >
      <Content>
        <div>The selected session is currently being used by another user.</div>

        <div>Only one user can access the same session at a time. Please try again later.</div>
      </Content>
    </Modal>
  );
};
